import React, { useMemo } from 'react';
import classNames from 'classnames';

export interface StepperProps {
  currentStep: number;
  totalSteps: number;
  showProgressBar?: boolean;
  className?: string;
}

export const Stepper: React.FC<StepperProps> = ({
  currentStep,
  totalSteps,
  showProgressBar = false,
  className,
}) => {
  const normalizedTotal = Math.max(1, totalSteps);
  const normalizedCurrent = Math.min(Math.max(1, currentStep), normalizedTotal);

  const percentage = useMemo(() => {
    if (normalizedTotal <= 1) return 100;
    return (normalizedCurrent / normalizedTotal) * 100;
  }, [normalizedCurrent, normalizedTotal]);

  return (
    <div className={classNames('w-full', className)}>
      <div className="flex items-center gap-2 mb-ds-2">
        <span className="text-ds-display-s font-medium text-ds-text-1">{normalizedCurrent}</span>
        <span className="text-ds-title font-light text-ds-text-inverse-3"> / </span>
        <span className="text-ds-display-s font-light text-ds-text-inverse-3">
          {normalizedTotal}
        </span>
      </div>
      {showProgressBar && (
        <div className="h-ds-2 w-full rounded-full bg-ds-bg-surface-soft-3 overflow-hidden">
          <div
            className="h-full rounded-full bg-ds-bg-surface-2 transition-all duration-300 ease-out"
            style={{ width: `${percentage}%` }}
          />
        </div>
      )}
    </div>
  );
};
